/**
 * Edge-triggered debounce. Bookkeeping only. `key` is only needed when one guard
 * instance covers several independent windows (cargo: one per box id) — an instance
 * dedicated to a single window (posture: one instance, shared across all posture keys)
 * can just omit it.
 */
export class CooldownGuard {
  private lastAt: Record<string, number> = {};

  constructor(private cooldownMs: number) {}

  ready(key = ""): boolean {
    return Date.now() - (this.lastAt[key] ?? 0) >= this.cooldownMs;
  }

  mark(key = ""): void {
    this.lastAt[key] = Date.now();
  }
}
